const STORAGE_KEY = 'u1card:platform-return-url';

export function normalizePlatformReturnUrl(value) {
  if (!value) return '';
  try {
    const url = new URL(String(value));
    const local = url.protocol === 'http:' && (url.hostname === 'localhost' || url.hostname === '127.0.0.1');
    if ((url.protocol !== 'https:' && !local) || url.username || url.password) return '';
    return url.origin;
  } catch {
    return '';
  }
}

export function cachePlatformReturnUrl(value) {
  const normalized = normalizePlatformReturnUrl(value);
  if (normalized) sessionStorage.setItem(STORAGE_KEY, normalized);
  return normalized;
}

export function platformReturnUrl() {
  return normalizePlatformReturnUrl(sessionStorage.getItem(STORAGE_KEY));
}

export function clearPlatformReturnUrl() {
  sessionStorage.removeItem(STORAGE_KEY);
}
